const getBackTo = (to: string, search: string) => {
  if (search.includes("?search=*&payment_settings=")) {
    return "/customer/points";
  }
  return to;
};

export default getBackTo;
